export const PROJECTS_I18N_ROOT = "circle_ai_projects";
export const PROJECTS_LIST_PATH = "/ai/projects" as const;
export const PROJECTS_DETAIL_PATH = "/ai/projects/$projectId" as const;
export const SEARCH_DEBOUNCE_MS = 300;
export const PROJECTS_PER_PAGE = 20;
export const ACTIVE_PROJECTS_TAB = "active";
export const ARCHIVED_PROJECTS_TAB = "archived";
export const PROJECTS_SCROLL_CONTAINER_ID =
  "circle-ai-projects-scroll-container";
// Container width (56rem) below which the detail page collapses its two-column
// layout into tabs. Matches the prior `[@container(min-width:56rem)]` threshold.
export const PROJECT_DETAIL_NARROW_BREAKPOINT_PX = 896;
